module.exports = __webpack_public_path__ + "assets_1789888786567/img/pic_8.bc65c1d3.png";